export const SET_PERIOD = (state, value) => {
  state.period = value
}

export const SET_FROM = (state, value) => {
  state.from = value
}

export const SET_TO = (state, value) => {
  state.to = value
}

export const SET_LABELS = (state, value) => {
  state.info.labels = value
}

export const SET_DATASETS = (state, value) => {
  state.info.datasets = value
}
